import style from "../../../assets/scss/sub/paymentHistory.module.scss";
import LeftBtnIcon from "../../../assets/images/mypage/left_button_icon.svg";
import RightBtnIcon from "../../../assets/images/mypage/right_button_icon.svg";
import React from "react";

export function useMyPageFunctions() {

    // 각각 데이터 함수
    function CommonResultField (
        {result, renderItem, emptyMessage}
        :{result: any[]; renderItem: (item:any, index:number) => React.ReactNode; emptyMessage: React.ReactNode}
    ){
        return(
            <div className={style.resultInfoContainer}>
                {result.length > 0? (
                    result.map((item, index) => renderItem(item,index))
                    )
                    :(
                        <div className={style.noPaymentInfo}>{emptyMessage}</div>
                    )
                }
            </div>
        )
    }

    // 페이징 함수
    function CommonPageField (
        {handlePageChange, currentPage, totalPages}
        :{handlePageChange: (page: number) => void, currentPage:number, totalPages: number}
    ) {
        const paginationRange = 5;
        const startPage = Math.max(0, Math.min(currentPage - Math.floor(paginationRange / 2), totalPages - paginationRange));
        const endPage = Math.min(totalPages, startPage + paginationRange);

        return(
            <div className={style.paginationContainer}>
                <div className={style.paginationDiv}>
                    <img
                        src={LeftBtnIcon} alt={"LeftBtnIcon"}
                        className={style.leftButtonImg}
                        onClick={() => handlePageChange(Math.max(currentPage - 1, 0))}
                    />
                    {Array.from({ length: endPage - startPage }, (_, i) => startPage + i).map((page) => (
                        <button
                            key={page}
                            className={`${style.paginationBtn} ${currentPage === page ? style.active : ""}`}
                            onClick={() => handlePageChange(page)}
                        >
                            {page + 1}
                        </button>
                    ))}
                    <img
                        src={RightBtnIcon} alt={"RightBtnIcon"}
                        className={style.rightButtonImg}
                        onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages - 1))}
                    />
                </div>
            </div>
        )
    }
    return{
        CommonResultField, CommonPageField
    }
}